import { render } from "./PostListContent.vue?vue&type=template&id=0d8a469a&scoped=true"
import script from "./PostListContent.vue?vue&type=script&lang=js"
export * from "./PostListContent.vue?vue&type=script&lang=js"

import "./PostListContent.vue?vue&type=style&index=0&id=0d8a469a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8a469a"]])

export default __exports__